// Dependencies
import { FC } from "react";

// Components
import RegistrationForm from "~/containers/RegistrationForm";

// Styles
import {
  StyledSignUpBackground,
  StyledFormPosition,
} from "./Registration.styled";

interface RegistrationProps {}

const Registration: FC<RegistrationProps> = () => {
  return (
    <StyledSignUpBackground>
      <StyledFormPosition>
        <RegistrationForm />
      </StyledFormPosition>
    </StyledSignUpBackground>
  );
};

export default Registration;
